import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkProgram  {
    _originalTypeClassName = "zERP.BO.WorkProgram";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkProgram.translate = translateService;
}
this.Days = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.IsFixHours = false;
this.StartDate = null;
this.IsRolling = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
IsFixHours:any;
StartDate:any;
IsRolling:any;
Days:any;
static setDays = ($this, items) => {
                if (items == null) items = [];
                if ($this.Days == null) $this.Days = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Days.length > 0) {
                    Domain.WorkProgram.removeDays($this, $this.Days[0]);
                }

                Domain.WorkProgram.addManyDays($this, copyItems);
            }
static addManyDays = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.WorkProgram.addDays($this, items[i]);
                }
            }
static addDays = ($this, item) => {
                if ($this.Days == null) $this.Days = [];
                if (item == null || $this.Days.indexOf(item) > -1) return;
                $this.Days.push(item);
}
static addRangeDays = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.WorkProgram.addDays($this, item));
            }
static removeDays = ($this, item) => {
                if ($this == null || $this.Days == null || $this.Days.indexOf(item) === -1) return;
                var _index = $this.Days.indexOf(item);
                $this.Days.splice(_index, 1);
}
static clearDays = ($this) => { $this.Days = null; }

static AddRollingWeekDays($this: any, week: any): any{for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => 7); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let day = new Domain.WorkDay();day.Day = Domain.WorkDay.ReturnWeekDay(i);day.Week = week;$this?.Days?.add(day);}

}
static AddWeekDays($this: any): any{for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => 7); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let day = new Domain.WorkDay();day.Day = Domain.WorkDay.ReturnWeekDay(i);day.Week = Domain.Week.First;$this?.Days?.add(day);}

}
static GetClassName(): any{return "WorkProgram";
}
static ImportWorkProgram(importFile: any): any{let info = "";
return info;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}